<template>
  <div id="app" :class="`main-${device}1`">
    <vue-header :active="active" @changeActive="changeActive"></vue-header>
    <transition name="fade-transform" mode="out-in">
      <router-view  v-if="isRouterAlive" />
    </transition>
    <vue-footer :active="active" @changeActive="changeActive"></vue-footer>
    <vue-button v-if="device=='mobile'" :text="text" :url="url"></vue-button>
    <vue-top></vue-top>
    <div class="examplecode" v-if="device=='pc'">
      <img :src="'https://mall-1258501264.cos.ap-guangzhou.myqcloud.com/mall/static/doomicase.jpg'" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'App',
    components: {
      'vue-header': () => import('@/components/v_header.vue'),
      'vue-footer': () => import('@/components/v_footer.vue'),
      'vue-button': () => import('@/components/fixedButton.vue'),
      'vue-top': () => import('@/components/backTop.vue'),
    },
    provide() {
      return {
        reload: this.reload,
      };
    },
    data(){
      return{
        isRouterAlive: true,
        active: window.localStorage.getItem('active')||0,
        text:'',
        url:''
      }
    },
    methods:{
      reload() {
        this.isRouterAlive = false;
        this.$nextTick(function() {
          this.isRouterAlive = true;
        });
      },
      changeActive(index){
        console.log(index)
        this.active=index
      }
    },
    watch: {
      '$route.path': function (newVal, oldVal) {
        switch(newVal){
          case '/index':
            this.active = 0;
            this.text='开店咨询';
            // this.url='http://mall.doomisoft.com';
            this.url='';
            break;
            case '/appointment':
            this.active = 1;
            this.text='开店咨询';
            // this.url='http://mall.doomisoft.com';
            this.url='';
            break;
            case '/microstation':
            this.active = 2;
            this.text='开通咨询';
            this.url='http://wz.doomisoft.com/register.html';
            break;
            case '/about':
            this.active = 3;
            this.text='开店咨询';
            // this.url='http://mall.doomisoft.com';
            this.url='';
            break;
          }
      }
    }
  }
</script>

<style>
  body,html{
    /* background: #f2f2f2; */
  }
  img{
    display: block;
  }
  #app{
    min-height: 100vh;
    /* overflow-x: hidden; */
  }
  .main-pc1{
    padding-top: 56px;
    background: white;
  }
  .main-mobile1{
    padding-top: 1.3333rem;
    overflow-x: hidden;
    background: #f4f4f4;
  }
  /* 取消浏览器默认样式 */
  * {
    margin: 0;
    padding: 0;
    list-style: none;
    text-decoration: none;
    box-sizing: border-box;
    /* user-select: none; */
    /* color: #666666; */
    word-break: break-all;
		/* font-family: '微软雅黑'; */
  }

  /* 设置默认pc宽度 */
  .main-pc .container{
      width: 1200px;
      left: 0;
      right: 0;
      margin: auto;
      position: relative;
  }

  /* 设置文本省略号 */
  .one-line {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
    
    .two-line {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    
    .three-line {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
    }
/* 弹性布局 */
  .rowFlex{
    display: flex;
    flex-direction: row;
  }
  
  .colFlex{
    display: flex;
    flex-direction: column;
  }
  
  .justifyFlex{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .jus_start_Flex{
    justify-content: flex-start;
  }
  
  .jus_end_Flex{
    justify-content: flex-end;
  }
  
  .align_start_Flex{
    align-items: flex-start;
  }
  
  .align_end_Flex{
    align-items: flex-end;
  }
 

 /* 页面进入动画 */
  .fade-transform-leave-active,
  .fade-transform-enter-active {
    transition: all .4s;
  }
  
  .fade-transform-enter {
    opacity: 0;
    /* transform: scale(0.98); */
  }
  
  .fade-transform-leave-to {
    opacity: 0;
    /* transform: scale(1); */
  }
  
  .pswp{
    z-index: 999999999 !important;
  }

  .examplecode{
    position: fixed;
    right: 30px;
    bottom: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #ffffff;
    box-shadow: 0 0 8px 2px rgba(0,0,0,0.1);
    border: 1px solid #eee;
    border-radius: 6px;
    z-index: 10000;
    overflow: hidden;
  }
  .examplecode h3{
    font-size: 16px;
  }
  .examplecode img{
    width: 200px;
    /* margin: 10px 0; */
  }
</style>



// WEBPACK FOOTER //
// src/App.vue